import localStorageService from 'app/services/localStorageService';
import axios from 'axios';

const waitForToken = async () => {
  let token = null;
  let tries = 0;
  while (!token && tries < 10) {
    token = localStorage.getItem('jwt_token');
    if (!token) {
      await new Promise((resolve) => setTimeout(resolve, 100)); // wait 100ms
      tries++;
    }
  }
  return token;
};

const myaxios = axios.create();

myaxios.interceptors.request.use(
  async (config) => {
    const token = await waitForToken(); // waits until token is available
    console.log("token from my axios",token);
    
     config.headers.Authorization = `Bearer ${token}`;
    
    return config;
  },
  (error) => Promise.reject(error)
);

export default myaxios;
